import React from 'react';
import './index.less';

import { Doughnut } from 'react-chartjs-2';
import 'chart.piecelabel.js';

import GenderData from './GenderData';
import { genAgesData, options } from './helpers';

import withIntl from '../../../../../shared/intl-hoc';

function Diagram({ intl, analytics, ages }) {
	return (
		<div className='analytics-diagram-wrapper'>
			<Doughnut
				data={genAgesData(analytics, ages, intl)}
				options={options(analytics)}
				width={360}
				height={360}
			/>
			<div className='analytics-diagram-inner'>
				<GenderData
					image='analytics-diagram-male'
					value={analytics.male}
					title={intl('Мужчин')}
				/>
				<GenderData
					image='analytics-diagram-female'
					value={analytics.female}
					title={intl('Женщин')}
				/>
			</div>
		</div>
	);
}

export default withIntl(Diagram);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/info/components/Analytics/Diagram/index.js